import Footer from "../../components/shared/Footer";
import Header from "../../components/shared/Header";
import Index from "../../components/home/Index";


const Home = () => {
 


  return (
    <>
      <Header />
     <Index />
      <Footer />

    </>
  );
};
export default Home;
